module.exports = __webpack_public_path__ + "img/2025-03-12d_2.d35e3c73.jpg";